module.exports = __webpack_public_path__ + "img/w3_sort_bars_asc_light.1f433cfa.png";